import Backbone from "backbone";
import _ from "underscore";

let Router = Backbone.Router.extend({
    routes: {
        "": "fpUnit",
        "map(/:fp/:unit)(/)": "mapRoute",
        ":fp(/:unit)(/)": "fpUnit",
        "availabilities/floorplan/:fp(/)": "availFallback"
    },
    fpUnit: _.noop,
    mapRoute: _.noop,
    availFallback: _.noop
});

export {Router};
